export const getYAxisTitle = (viewMode, rType, chartTopsMapping, topsMode) => {
  const rTypeText = !rType || rType === 'cases' ? 'respondent' : 'response'

  switch (viewMode) {
    case 'stacked':
      return `% of ${rTypeText}s`
    case 'stackedCounts':
      return `Number of ${rTypeText}s`
    case 'score':
      return 'scores'
    case 'meanScore':
      return 'Mean'
    case 'boxScore': {
      return `${chartTopsMapping?.find(v => v.value === topsMode)?.text ?? ''} %`.trim()
    }
    default:
      return null
  }
}
